import http from '@/core/http'
import { map } from 'lodash'

const url = 'links'

const state = {
  itens: [],
  item: {
    url: '',
    name: '',
    campaignTypeId: '',
    tag: '',
    config: {
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
      utm_term: '',
      utm_content: '',
    }
  },
  itensSelect: [],
  totalItens: 0,
  urlPlataforma: '',
}

const headers = { moduloname: 'afiliados' }

const actions = {
  getItens: async ({ commit },payload) => {
    const result = await http.get(url, { params: payload, headers })
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },

  getItensSelect: async ({ commit }, payload) => {
    const result = await http.get(`${url}/types`, { params: payload, headers })
    delete result.data.date
    commit('LISTA_ITENS_SELECT', result.data)
    return Promise.resolve(result)
  },

  getItem: async ({ commit }, payload) => {
    const result = await http.get(`${url}/view`, { params: payload, headers })
    delete result.data.date
    if (!result.data.config) {
      result.data.config = {
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        utm_term: '',
        utm_content: '',
      }
    }
    commit('LISTA_ITEM', result.data)
    return Promise.resolve(result)
  },

  cadastrarItem: async (_, payload) => {
    const result = await http.post(url, payload, { headers })
    return Promise.resolve(result)
  },

  editarItem: async (_, payload) => {
    const result = await http.put(url, payload, { headers })
    return Promise.resolve(result)
  },

  limparItem: ({ commit }) => {
    commit('LIMPAR_ITEM')
  },

  limparItems: ({ commit }) => {
    commit('LIMPAR_ITEMS')
  },

  generateSmarticoLink: async (_, payload) => {
    console.log('📡 [STORE] Iniciando chamada para gerar link Smartico')
    console.log('📋 [STORE] Payload enviado:', payload)
    
    // Adicionar ação para identificar a requisição
    const payloadWithAction = {
      ...payload,
      action: 'generateSmartico'
    }
    
    const result = await http.post(url, payloadWithAction, { headers })
    
    console.log('📨 [STORE] Resposta recebida:', result.data)
    return Promise.resolve(result)
  },

  editSmarticoLink: async (_, payload) => {
    // Adicionar flag para identificar como link Smartico
    const payloadWithFlag = {
      ...payload,
      isSmartico: true
    }

    const result = await http.put(url, payloadWithFlag, { headers })
    return Promise.resolve(result)
  },

  createDestinationLink: async (_, payload) => {
    const payloadWithAction = {
      ...payload,
      action: 'createDestination'
    }

    const result = await http.post(url, payloadWithAction, { headers })
    return Promise.resolve(result)
  }
}

const mutations = {
  'LISTA_ITENS' (state, payload) {
    state.itens = payload.resultMap
    state.totalItens = payload.totalItens
    state.urlPlataforma = payload.urlPlataforma
  },

  'LISTA_ITENS_SELECT' (state, payload) {
    state.itensSelect = payload
  },

  'LISTA_ITEM' (state, payload) {
    state.item = Object.assign({}, payload)
  },

  'LIMPAR_ITEM'(state) {
    state.item = {
      url: '',
      name: '',
      campaignTypeId: '',
      tag: '',
      config: {
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        utm_term: '',
        utm_content: '',
      }
    }
  },
  
  'LIMPAR_ITEMS' (state) {
    state.itens = []
    state.totalItens = 0
  },
}

const getters = {
  listaItens: state => state.itens,
  totalItens: (state) => state.totalItens,
  item: state => state.item,
  urlPlataforma: state => state.urlPlataforma,
  listaItensSelect: (state) => {
    return map(state.itensSelect, item => {
      return {
        text: item.name,
        value: item.id
      }
    })
  },
}

export default { namespaced: true, state, actions, mutations, getters }